import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption , MDBIcon, MDBFormInline} from "mdbreact";
import {  MDBRow, MDBCol } from "mdbreact";

import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { api } from '../../api';
import Swal from 'sweetalert2'
const { Option } = Select;

export default class Modaladdwork extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   send_comment1:"",
   send_comment4:"",

   filecomment1:null,
   filecomment2:null,

   name_workorder:'',//ชื่องาน
   namecustomer_workorder:'',//ชื่อลูกค้า
   tel_workorder:'',//เบอร์ลูกค้า
   idline_workorder:'',//ไลน์ลูกค้า
   facebook_workorder:'',//เฟชบุคลูกค้า
   appointment_workorder:'',//นัดรับงาน
   example_workorder:'',//ตัวอย่าง
   description_workorder:'',//รายละเอียด
   price_workorder:'0',//จำนวนเงิน
   deposit_workorder:'0',//เงินมัดจำ
   remain_workorder:'0',//คงเหลือ
   paymentstatus_workorder:'',//สถานะการจ่าย
   code_workorder:'',//รหัส
   showcode1:'',//รหัส
   status_workorder:'1',
   coderun:'',

   radio: '-',
   materialvinyl: '-',
   papertype:'-',
   statecut:'-',

   work:[],
   onChangetypecutomer:[],



}

//this.handleChange = this.handleChange.bind(this);
//this.handleChange2 = this.handleChange2.bind(this);
//this.handleChange3 = this.handleChange3.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
//this.handleChange4 = this.handleChange4.bind(this);
this.handleChangefile = this.handleChangefile.bind(this);
this.onTextChange = this.onTextChange.bind(this);
this.onChangetype = this.onChangetype.bind(this);
this.onClick = this.onClick.bind(this);
this.onClickmaterialvinyl = this.onClickmaterialvinyl.bind(this);
this.onClickpapertype = this.onClickpapertype.bind(this);
this.onClickstatecut = this.onClickstatecut.bind(this);
this.getwork = this.getwork.bind(this);
this.onChangetypecutomer = this.onChangetypecutomer.bind(this);

}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  //this.props.getwork();
  this.getwork()
}

handleChangefile(event) {    this.setState({example_workorder: event.target.files[0]});  }

onTextChange = (e) => {
  this.setState({ [e.target.name]: e.target.value })
}

onChangetype(value) {
  this.setState({ paymentstatus_workorder:value})
}

onChangetypecutomer(value) {
 // this.setState({ paymentstatus_workorder:value})
//const ssd = value.toLocaleString();
const idw = this.state.work.filter( ({ id_workorder }) => id_workorder === value);
this.setState({ namecustomer_workorder:idw[0].namecustomer_workorder})
this.setState({ tel_workorder:idw[0].tel_workorder})
this.setState({ idline_workorder:idw[0].idline_workorder})
this.setState({ facebook_workorder:idw[0].facebook_workorder})


//console.log(idw[0].namecustomer_workorder);
//console.log(this.state.work);
}

onClick = (nr) => () => {
  this.setState({
    radio: nr,
  });
};

onClickmaterialvinyl = (nr) => () => {
  this.setState({
    materialvinyl: nr,
  });
};

onClickpapertype = (nr) => () => {
  this.setState({
    papertype: nr,
  });
};

onClickstatecut = (nr) => () => {
  this.setState({
    statecut: nr,
  });
};

getwork (){
  this.setState({ loading:true})
    api.get('selectworksl.php')
    .then(res => {
    //  console.log(res);
    //  this.setState({ bankname: res.data, loading: false })
      this.setState({ work: res.data,  loading: false })
    }) 
}





 componentDidMount() {
    //  const { id_send } = this.props.id_send
   //   console.log(id_send);
     // this.setState({ id_send:this.props.id_send})
      setTimeout(() => {
        //ภายใน
        api.get('selectworksl.php')
        .then(res => {
        //  console.log(res);
          if (res.data.length !== 0) {
            // this.showitem = true;
            // console.log(res)
            // console.log(res.data.length)
           
            // const sum1 =  res.data[0].coderun  ;
            //  const sum1 =  Intl(this.state.status_workorder)   ;
            //  console.log(Number(res.data[0].coderun)+5)
            const sum1 =  Number(res.data[0].coderun)+1 ;
            const co = sum1.toString()  ;
            const s = co.padStart(5, "0");
            
            const showcode = "SL-"+s;
            this.setState({ code_workorder: showcode,coderun:co ,showcode1 : showcode})
          }else{
            // const aa = sprintf('sl','%04d', 1)
            const s = "1".padStart(5, "0");
            const showcode = "SL-"+s;
            this.setState({ code_workorder: showcode,coderun: 1,showcode1 : showcode})
            // window.location.href = '/'
          }
           //  this.setState({ bankname: res.data, loading: false })
          // this.setState({ Expert: res.data})
        }) 

      }, 0);

  }

//   getExpert() {
//     setTimeout(() => {
//       //ภายใน
//        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
//       .then(res => {
//         console.log(res);
//       //  this.setState({ bankname: res.data, loading: false })
//         this.setState({ Expert: res.data})
//       }) 

//     }, 0);

// }


 // handleChange(event) {    this.setState({filecomment1: event.target.files[0]});  }
 // handleChange3(event) {    this.setState({filecomment2: event.target.files[0]});  }
 // handleChange2(event) {    this.setState({send_comment1: event.target.value});  }
 // handleChange4(event) {    this.setState({send_comment4: event.target.value});  }


  handleSubmit(e) {
    e.preventDefault();
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("code_workorder", this.state.code_workorder);
      datafrm.append("name_workorder", this.state.name_workorder);
      datafrm.append("namecustomer_workorder", this.state.namecustomer_workorder);
      datafrm.append("tel_workorder", this.state.tel_workorder);
      datafrm.append("idline_workorder", this.state.idline_workorder);
      datafrm.append("facebook_workorder", this.state.facebook_workorder);
      datafrm.append("appointment_workorder", this.state.appointment_workorder);
      datafrm.append("example_workorder", this.state.example_workorder);
      datafrm.append("description_workorder", this.state.description_workorder);
      datafrm.append("material_workorder", this.state.radio);
      datafrm.append("materialvinyl_workorder", this.state.materialvinyl);
      datafrm.append("papertype_workorder", this.state.papertype);
      datafrm.append("statecut_workorder", this.state.statecut);
      datafrm.append("price_workorder", this.state.price_workorder);
      datafrm.append("deposit_workorder", this.state.deposit_workorder);
      datafrm.append("remain_workorder", this.state.remain_workorder);
      datafrm.append("paymentstatus_workorder", this.state.paymentstatus_workorder);
      datafrm.append("status_workorder", this.state.status_workorder);
      datafrm.append("coderun", this.state.coderun);
      

     
    

      
      api.post("uploadpicexwork.php",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
  
    console.warn(res);
    console.log("response: ", res)


     if (res.data.length !== 0) {
      // this.showitem = true;
       console.log(res)
      // console.log(res.data.length) 
     }else{
       // window.location.href = '/'
     }


    if (res.data.status = 'success') {
      Swal.fire({
        title: 'บันทึกใบสั่งงานสำเร็จ',
        icon: 'success',
      // showCancelButton: true,
        confirmButtonText: 'ตกลง',
      // cancelButtonText: 'No, keep it'
      }).then((result) => {
        this.toggle();  
        this.props.getwork();
     // this.getworklist();
        
      })

     // message.success("อัพโหลไฟล์สำเร็จ")
     // window.location.href = '/adminfaculty'
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }
  })


//อัพเดทสถานะ
  // Axios
  // // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
  //   .post("https://conference.kpru.ac.th/PHPAPI/updatestapat4.php",datafrm)
  //   .then(res => {
  //     console.log("response: ", res)
 
  //     if (res.data.length !== 0) {
  //      // this.showitem = true;
  //       console.log(res)
  //       console.log(res.data.length)
  //    }else{
  //     // window.location.href = '/'
  //    }
  //    this.toggle()
  //  })
  // this.toggle()


}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()
 


  }

  

    render() {
// console.log(this.state.name_workorder)
// console.log(this.state.namecustomer_workorder)
// console.log(this.state.tel_workorder)
// console.log(this.state.idline_workorder)
// console.log(this.state.facebook_workorder)
// console.log(this.state.appointment_workorder)
// console.log(this.state.example_workorder)
// console.log(this.state.description_workorder)
// console.log(this.state.price_workorder)
// console.log(this.state.deposit_workorder)
// console.log(this.state.remain_workorder)
// console.log(this.state.paymentstatus_workorder)
// console.log(this.state.code_workorder) 

// console.log(this.state.radio) 
// console.log(this.state.materialvinyl) 
// console.log(this.state.papertype) 
console.log(this.state.work) 
console.log("44554") 



//console.log("1".padStart(5, "0"));
        return (
            <MDBContainer>
            <MDBBtn onClick={this.toggle}>เพิ่มใบสั่งงาน</MDBBtn>

            
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg" >
              <MDBModalHeader toggle={this.toggle} className="text-center"><MDBIcon icon="registered" /> ใบสั่งงาน</MDBModalHeader><br/>
              {/* <div className="text-center"><h4>ร้านลูกแม่น้ำปิงไวนิล 055-023245, 092-5583982, 0827730380</h4></div> */}
              
              
              <MDBModalBody className="text-left">
              <div>
                <h5 className="text-left font-weight-bold"> รหัส : {this.state.showcode1}</h5>   <br/>
              <form onSubmit={this.handleSubmit}>
                            <div className="mb-2">
                                <label className="font-weight-bold"><MDBIcon icon="bible" /> ชื่องาน</label>
                                <input className="form-control" onChange={this.onTextChange} name="name_workorder"
                                    value={this.state.name_workorder} placeholder="" required />
                            </div>
                            <div className="mb-2">
                                <label className="font-weight-bold"><MDBIcon icon="money-check-alt" /> ค้นหาลูกค้า</label><br/>
                                <Select
                                    showSearch
                                    style={{ width:"100%" }}
                                    placeholder="ค้นหาลูกค้า"
                                    optionFilterProp="children"
                                    onChange={this.onChangetypecutomer}
                                    onFocus={this.onFocus}
                                    onBlur={this.onBlur}
                                    onSearch={this.onSearch}
                                    filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                  {this.state.work.map((work,index )  => 
                                <Option value={work.id_workorder}>{work.namecustomer_workorder}</Option>
                                )}
                              
                                 </Select>
                   
                            </div><br/>
                            <hr/>
                            <MDBRow>
                           
                              <MDBCol md="4">
                                 <div className="mb-2">
                                   <label className="font-weight-bold"><MDBIcon icon="user-times" /> ชื่อลูกค้า</label>
                                   <input className="form-control" onChange={this.onTextChange} name="namecustomer_workorder"
                                    value={this.state.namecustomer_workorder} placeholder="" required />
                                 </div>
                                </MDBCol>
                              <MDBCol md="4">
                                  <div className="mb-2">
                                      <label className="font-weight-bold"><MDBIcon icon="phone-volume" /> เบอร์โทรลูกค้า</label>
                                      <input className="form-control" onChange={this.onTextChange} name="tel_workorder"
                                          value={this.state.tel_workorder} placeholder="" required />
                                  </div>
                              </MDBCol>
                              <MDBCol md="4">
                                 <div className="mb-2">
                                 <label className="font-weight-bold"><MDBIcon fab icon="line" /> ID LINE</label>
                                 <input className="form-control" onChange={this.onTextChange} name="idline_workorder"
                                    value={this.state.idline_workorder} placeholder="" required />
                                  </div>
                              </MDBCol>
                            </MDBRow>

                            <MDBRow>
                              <MDBCol md="4">
                                <div className="mb-2">
                                        <label className="font-weight-bold"><MDBIcon fab icon="facebook" /> FACEBOOK</label>
                                        <input className="form-control" onChange={this.onTextChange} name="facebook_workorder"
                                            value={this.state.facebook_workorder} placeholder="" required />
                                </div>
                              </MDBCol>
                              <MDBCol md="4">
                                <div className="mb-2">
                                    <label className="font-weight-bold"><MDBIcon icon="calendar-alt" /> นัดรับงานวันที่</label>
                                    <input className="form-control" type="date" onChange={this.onTextChange} name="appointment_workorder"
                                        value={this.state.appointment_workorder} placeholder="" required />
                                </div>
                              </MDBCol>
                              <MDBCol md="4">
                                 <div className="mb-2">
                                  <label className="font-weight-bold"><MDBIcon icon="file-image" /> ไฟล์ตัวอย่าง .jpg (ถ้ามี)</label>
                                  {/* <MDBInput   group   type="file" validate error="wrong"
                                    success="right"  name="file" value={this.state.value} onChange={this.handleChange}/> */}

                                  {/* <input className="custom-file-input" type="file" onChange={this.handleChangefile} name="auth_agency" 
                                      value={this.state.auth_agency} placeholder="" required /> */}
                                       {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                        success="right"  name="file" accept="image/x-png,image/jpg,image/jpeg" value={this.state.value} onChange={this.handleChange} required/> */}
                                        <input type="file" id="img" name="example_workorder" onChange={this.handleChangefile} accept="image/x-png,image/jpg,image/jpeg" ></input>
                                </div>
                              </MDBCol>
                            </MDBRow>

                            <hr/>

                            <MDBRow>
                              <MDBCol md="12">
                                <div className="mb-2">
                                  <label className="font-weight-bold"><MDBIcon icon="indent" /> รายละเอียด</label>
                                  <textarea className="form-control" type="text" onChange={this.onTextChange} name="description_workorder"
                                      value={this.state.description_workorder} placeholder="" required />
                                </div>
                              </MDBCol>
                            </MDBRow>
                                        <br/>
                            <MDBRow>
                              <MDBCol md="6">
                                <div className="mb-2">
                                <label className="font-weight-bold"><MDBIcon icon="cubes" /> ประเภทวัสดุ</label>
                                   <MDBFormInline>
                                          <MDBInput
                                            gap
                                            onClick={this.onClick('ไวนิล')}
                                            checked={this.state.radio === 'ไวนิล' ? true : false}
                                            label="ไวนิล"
                                            type="radio"
                                            id="radio1"
                                            containerClass="mr-5"
                                          />
                                          <MDBInput
                                            gap
                                            onClick={this.onClick('สติ๊กเกอร์')}
                                            checked={this.state.radio === 'สติ๊กเกอร์' ? true : false}
                                            label="สติ๊กเกอร์"
                                            type="radio"
                                            id="radio2"
                                            containerClass="mr-5"
                                          />
                                          {/* <MDBInput
                                            gap
                                            onClick={this.onClick(3)}
                                            checked={this.state.radio === 3 ? true : false}
                                            label="3"
                                            type="radio"
                                            id="radio3"
                                            containerClass="mr-5"
                                          /> */}
                                    </MDBFormInline>
                                </div>
                              </MDBCol>

                                          {this.state.radio == 'ไวนิล' ?<>
                                          <MDBCol md="6">
                                            <div className="mb-2">
                                            <label className="font-weight-bold"><MDBIcon icon="tools" /> การติดตั้ง</label>
                                              <MDBFormInline>
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickmaterialvinyl('พับเจาะ')}
                                                        checked={this.state.materialvinyl === 'พับเจาะ' ? true : false}
                                                        label="พับเจาะ"
                                                        type="radio"
                                                        id="radio4"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickmaterialvinyl('พับไม่เจาะ')}
                                                        checked={this.state.materialvinyl === 'พับไม่เจาะ' ? true : false}
                                                        label="พับไม่เจาะ"
                                                        type="radio"
                                                        id="radio5"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickmaterialvinyl('ติดตั้ง/ติดโครง')}
                                                        checked={this.state.materialvinyl === 'ติดตั้ง/ติดโครง' ? true : false}
                                                        label="ติดตั้ง/ติดโครง"
                                                        type="radio"
                                                        id="radio6"
                                                        containerClass="mr-5"
                                                      />
                                                </MDBFormInline>
                                            </div>
                                          </MDBCol>
                                          </> : <> 
                                          {this.state.radio == 'สติ๊กเกอร์' ?<>
                                          <MDBCol md="6">
                                            <div className="mb-2">
                                            <label className="font-weight-bold"><MDBIcon icon="tools" /> การติดตั้ง</label>
                                              <MDBFormInline>
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickmaterialvinyl('ไม่ติด')}
                                                        checked={this.state.materialvinyl === 'ไม่ติด' ? true : false}
                                                        label="ไม่ติด"
                                                        type="radio"
                                                        id="radio7"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickmaterialvinyl('ติดฟิว')}
                                                        checked={this.state.materialvinyl === 'ติดฟิว' ? true : false}
                                                        label="ติดฟิว"
                                                        type="radio"
                                                        id="radio8"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickmaterialvinyl('ติดโฟม')}
                                                        checked={this.state.materialvinyl === 'ติดโฟม' ? true : false}
                                                        label="ติดโฟม"
                                                        type="radio"
                                                        id="radio9"
                                                        containerClass="mr-5"
                                                      />
                                                        <MDBInput
                                                        gap
                                                        onClick={this.onClickmaterialvinyl('ตัดแยกชิ้น')}
                                                        checked={this.state.materialvinyl === 'ตัดแยกชิ้น' ? true : false}
                                                        label="ตัดแยกชิ้น"
                                                        type="radio"
                                                        id="radio99"
                                                        containerClass="mr-5"
                                                      />
                                                </MDBFormInline>
                                            </div>
                                          </MDBCol>
                                          </>:<>กรุณาเลือกประเภท</>}
                                          </>}

                            </MDBRow>
                            <br/>
                            <MDBRow>
                              <MDBCol md="12">
                              <div className="mb-2">
                                            <label className="font-weight-bold"><MDBIcon icon="newspaper" /> ชนิดกระดาษ</label>
                                              <MDBFormInline>
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('สติกเกอร์PPขาวเงา')}
                                                        checked={this.state.papertype === 'สติกเกอร์PPขาวเงา' ? true : false}
                                                        label="สติกเกอร์ PP ขาวเงา"
                                                        type="radio"
                                                        id="radio10"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('สติกเกอร์PPด้าน')}
                                                        checked={this.state.papertype === 'สติกเกอร์PPด้าน' ? true : false}
                                                        label="สติกเกอร์ PP ด้าน"
                                                        type="radio"
                                                        id="radio11"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('สติกเกอร์PPใส')}
                                                        checked={this.state.papertype === 'สติกเกอร์PPใส' ? true : false}
                                                        label="สติกเกอร์ PP ใส"
                                                        type="radio"
                                                        id="radio12"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('สติกเกอร์หลังเขียว')}
                                                        checked={this.state.papertype === 'สติกเกอร์หลังเขียว' ? true : false}
                                                        label="สติกเกอร์ หลังเขียว"
                                                        type="radio"
                                                        id="radio13"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('สติกเกอร์คราฟ')}
                                                        checked={this.state.papertype === 'สติกเกอร์คราฟ' ? true : false}
                                                        label="สติกเกอร์ คราฟ"
                                                        type="radio"
                                                        id="radio14"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษอาร์ด128g')}
                                                        checked={this.state.papertype === 'กระดาษอาร์ด128g' ? true : false}
                                                        label="กระดาษอาร์ด 128g"
                                                        type="radio"
                                                        id="radio15"
                                                        containerClass="mr-5"
                                                      />
                                                       <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษอาร์ด158g')}
                                                        checked={this.state.papertype === 'กระดาษอาร์ด158g' ? true : false}
                                                        label="กระดาษอาร์ด 158g"
                                                        type="radio"
                                                        id="radio16"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษอาร์ด260g')}
                                                        checked={this.state.papertype === 'กระดาษอาร์ด260g' ? true : false}
                                                        label="กระดาษอาร์ด 260g"
                                                        type="radio"
                                                        id="radio17"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษอาร์ด350g')}
                                                        checked={this.state.papertype === 'กระดาษอาร์ด350g' ? true : false}
                                                        label="กระดาษอาร์ด 350g"
                                                        type="radio"
                                                        id="radio18"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษอาร์ดป็องแป้ง')}
                                                        checked={this.state.papertype === 'กระดาษอาร์ดป็องแป้ง' ? true : false}
                                                        label="กระดาษอาร์ด ป็องแป้ง"
                                                        type="radio"
                                                        id="radio19"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษคราฟ')}
                                                        checked={this.state.papertype === 'กระดาษคราฟ' ? true : false}
                                                        label="กระดาษ คราฟ"
                                                        type="radio"
                                                        id="radio20"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษเทกเจอร์')}
                                                        checked={this.state.papertype === 'กระดาษเทกเจอร์' ? true : false}
                                                        label="กระดาษเทกเจอร์"
                                                        type="radio"
                                                        id="radio21"
                                                        containerClass="mr-5"
                                                      />
                                                      <MDBInput
                                                        gap
                                                        onClick={this.onClickpapertype('กระดาษA470g')}
                                                        checked={this.state.papertype === 'กระดาษA470g' ? true : false}
                                                        label="กระดาษA4 70g"
                                                        type="radio"
                                                        id="radio22"
                                                        containerClass="mr-5"
                                                      />
                                                </MDBFormInline>
                                            </div>
                              </MDBCol>
                            </MDBRow>

                            <br/>
                            <MDBRow>
                              <MDBCol md="12">
                                <div className="mb-2">
                                  <label className="font-weight-bold"><MDBIcon icon="cut" /> ตัด</label>
                                  <MDBFormInline>
                                      <MDBInput
                                        gap
                                        onClick={this.onClickstatecut('ตัดแยกชิ้น')}
                                        checked={this.state.statecut === 'ตัดแยกชิ้น' ? true : false}
                                        label="ตัดแยกชิ้น"
                                        type="radio"
                                        id="radio23"
                                        containerClass="mr-5"
                                      />
                                      <MDBInput
                                        gap
                                        onClick={this.onClickstatecut('ไม่ตัด')}
                                        checked={this.state.statecut === 'ไม่ตัด' ? true : false}
                                        label="ไม่ตัด"
                                        type="radio"
                                        id="radio24"
                                        containerClass="mr-5"
                                      />
                                      {/* <MDBInput
                                        gap
                                        onClick={this.onClick(3)}
                                        checked={this.state.radio === 3 ? true : false}
                                        label="3"
                                        type="radio"
                                        id="radio3"
                                        containerClass="mr-5"
                                      /> */}
                                    </MDBFormInline>
                                </div>
                              </MDBCol>
                            </MDBRow>
                                        




                            <hr/>

                            <MDBRow>
                              <MDBCol md="4">
                                <div className="mb-2">
                                        <label className="font-weight-bold"><MDBIcon icon="donate" /> จำนวนเงิน</label>
                                        <input className="form-control" onChange={this.onTextChange} name="price_workorder"
                                            value={this.state.price_workorder} placeholder="" required />
                                </div>
                              </MDBCol>
                              <MDBCol md="4">
                                <div className="mb-2">
                                        <label className="font-weight-bold"><MDBIcon icon="hand-holding-usd" /> จำนวนเงินมัดจำ</label>
                                        <input className="form-control" onChange={this.onTextChange} name="deposit_workorder"
                                            value={this.state.deposit_workorder} placeholder="" required />
                                </div>
                              </MDBCol>
                              <MDBCol md="4">
                              <div className="mb-2">
                                        <label className="font-weight-bold"><MDBIcon icon="comments-dollar" /> คงเหลือ</label>
                                        <input className="form-control" onChange={this.onTextChange} name="remain_workorder"
                                            value={this.state.remain_workorder} placeholder="" required />
                                </div>
                              </MDBCol>
                            </MDBRow>
                          

                            <div className="mb-2">
                                <label className="font-weight-bold"><MDBIcon icon="money-check-alt" /> ประเภทการชำระ</label><br/>
                                <Select
                                    showSearch
                                    style={{ width:"100%" }}
                                    placeholder="เลือกประเภทการชำระ"
                                    optionFilterProp="children"
                                    onChange={this.onChangetype}
                                    onFocus={this.onFocus}
                                    onBlur={this.onBlur}
                                    onSearch={this.onSearch}
                                    filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                <option value="1">แบบเงินสด</option>
                                <option value="2">แบบเบิกจ่าย</option>
                              
                                 </Select>
                            </div><br/>

                            {/* <p className="purple-text text-center">ตรวจสอบข้อมูลว่าถูกต้องครบถ้วน</p> */}
                            <div className="mt-3 text-center" >
                                <MDBBtn type="submit" color="primary" className="text-center"> <MDBIcon far icon="save" /> บันทึก</MDBBtn>
                            </div>


                        </form>


              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> */}
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
